export default __webpack_public_path__ + "static/media/confiance.4ce14460.jpg";